// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoLocationOutlinedSvg from "@fishx/icons-svg/es/asn/PtoLocationOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoLocationOutlined = function PtoLocationOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoLocationOutlinedSvg
  }));
};

PtoLocationOutlined.displayName = 'PtoLocationOutlined';
export default React.forwardRef(PtoLocationOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoLocationOutlined.js
// module id = 3907
// module chunks = 0